import type { BaseResponseSummary } from "@/model/base-payload";

export const RECOMMENDATION_MODULE = {
  LIKE: "like",
  SAVE: "save",
  DELETE: "delete",
  READ: "read",
  SHOW: "show",
} as const;

export type RecommendationModule =
  (typeof RECOMMENDATION_MODULE)[keyof typeof RECOMMENDATION_MODULE];

export type RecommendationStatusRequestData = {
  loginGroupId: string;
  memberId: string;
  groupId: string;
  module: RecommendationModule;
  cohortId: string;
  value: boolean;
};

export type RecommendationStatusResponseData = {
  response: BaseResponseSummary;
};
